import { Postcode } from '@dreryk/address-common-api';

import { commonTranslationKeys, FieldControllerProps, FormContextValues } from '@dreryk/react-common';
import { ClassNameProp, PostcodeInput } from '@dreryk/react-components';

import { prefixFieldName } from '../common.utils';

type PostalCodeFieldProps = Pick<FormContextValues, 'register'> &
   Pick<FieldControllerProps<'postcode', Postcode | null>, 'name' | 'required'> &
   ClassNameProp & {
      readonly prefix?: string;
   };

const PostalCodeField = (props: PostalCodeFieldProps): JSX.Element => {
   const { name, prefix, register } = props;
   const fieldName = prefixFieldName(name, prefix);
   const controller = register(fieldName, {
      required: true,
   });
   return (
      <PostcodeInput controller={controller} label={commonTranslationKeys.addressData.zipCode} testId={fieldName} />
   );
};

export { PostalCodeField };
